const routes = [
    {
        path: "/prep/reports",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "prepexamscore_report"
        }
    }
];

export default routes;
